import './cursor.css'

const IS_TOUCHSCREEN =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    (navigator as any).msMaxTouchPoints > 0

const cursor = document.getElementById('cursor')!
const dataCursor = Array.from(
    document.querySelectorAll<HTMLElement>('[data-cursor]'),
)

let freeze: boolean = false

export function processElement(element: HTMLElement) {
    if (!element.dataset.cursor) return
    if (IS_TOUCHSCREEN) return

    element.addEventListener('mouseover', (ev) => {
        ev.stopImmediatePropagation()

        updateFromHoveredElement(element)
    })
}

export function setCursorElement(type: string = 'normal'): HTMLElement {
    let element: HTMLElement | null = null

    for (const child of Array.from(cursor.children) as HTMLElement[]) {
        if (child.classList.contains(`${type}-cursor`)) {
            child.classList.remove('hidden')
            element = child
        } else {
            child.classList.add('hidden')
        }
    }

    if (!element) throw new Error(`${type} is not a valid cursor type`)

    return element
}

function updateFromHoveredElement(element: HTMLElement): void {
    const type = element.dataset.cursor ?? 'normal'

    parseCursorOptions(element, setCursorElement(type))
}

function parseCursorOptions(
    element: HTMLElement,
    cursorChild: HTMLElement,
): void {
    const options = new Set((element.dataset.cursorOptions ?? '').split(' '))

    const { width, height, x, y } = element.getBoundingClientRect()

    if (options.has('freeze')) {
        freeze = true

        cursor.style.top = `${y}px`
        cursor.style.left = `${x}px`
    } else {
        freeze = false
    }

    if (options.has('bounds')) {
        cursorChild.style.width = `${width}px`
        cursorChild.style.height = `${height}px`
    } else {
        cursorChild.style.width = ''
        cursorChild.style.height = ''
    }
}

if (!IS_TOUCHSCREEN) {
    window.addEventListener('mousemove', (ev) => {
        if (freeze) return

        cursor.style.top = `${ev.clientY - cursor.clientHeight / 2}px`
        cursor.style.left = `${ev.clientX - cursor.clientWidth / 2}px`
    })

    for (const cursorModifier of dataCursor) {
        processElement(cursorModifier)
    }
}
